// components/AwardsSlider.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import HorizontalScroller from './home/HorizontalScroller';
import { normalizeMediaUrl } from '../api/base';

const Wrap = styled.section` margin:24px 0; `;

function normAward(x){
  if (!x) return null;
  const id = x.id ?? x.slug ?? Math.random();
  const title =
    x.title || x.name || x.label || x.slug || 'Без названия';
  const to = x.href || (x.id != null ? `/awards/${x.id}` : '#');

  const raw =
    x.img ||
    x.image ||
    x.image_thumb ||
    (x.featured_media?.thumbnail_url || x.featured_media?.url) ||
    '';
  const cover = raw ? normalizeMediaUrl(raw) : '';

  const desc = x.description || x.desc || '';
  return { id, title, to, cover, desc };
}

export default function AwardsSlider({
  items = [],
  // как просили: 4 → 2 → 2 → 1
  perViewDesktop = 4,
  perViewTablet  = 2,
  perViewMobile  = 2,
  perViewTiny    = 1,
  // размеры — как у CollectionsSlider
  itemMin = 220,
  itemMax = 330,
  pad = 8,
  gap = 12,
}) {
  const list = (Array.isArray(items) ? items : [])
    .map(normAward)
    .filter(Boolean);

  if (!list.length) return null;

  // Поведение как в CollectionsSlider: при >2 колонках — растягиваем на 100%
  const isCompactDesktop = perViewDesktop <= 2;
  const maxWidthValue = isCompactDesktop
    ? perViewDesktop * itemMax + gap * (perViewDesktop - 1) + pad * 2
    : '100%';
  const shouldLimitDesktop = !isCompactDesktop;

  return (
    <Wrap>
      <HorizontalScroller
        perViewDesktop={perViewDesktop}
        perViewTablet={perViewTablet}
        perViewMobile={perViewMobile}
        perViewTiny={perViewTiny}
        itemMin={itemMin}
        itemMax={itemMax}
        maxWidth={maxWidthValue}
        centered
        pad={pad}
        gap={gap}
        limitDesktopWidth={shouldLimitDesktop}
      >
        {list.map((a) => (
          <div key={String(a.id)} style={{ width: 'var(--col-width)' }}>
            <Link
              to={a.to}
              aria-label={a.title}
              style={{
                display:'block',
                background:'var(--card)',
                border:'1px solid var(--bdr)',
                borderRadius:16,
                overflow:'hidden',
                boxShadow:'var(--shadow)',
                color:'inherit',
                textDecoration:'none',
              }}
            >
              {a.cover && (
                <img
                  src={a.cover}
                  alt={a.title}
                  loading="lazy"
                  decoding="async"
                  style={{
                    height:170,           // как у коллекций
                    width:'100%',
                    objectFit:'cover',
                    display:'block',
                  }}
                />
              )}
              <div style={{ padding:'10px 12px' }}>
                <h4
                  title={a.title}
                  style={{
                    margin:'0 0 4px',
                    fontSize:16,
                    lineHeight:1.25,
                    display:'-webkit-box',
                    WebkitBoxOrient:'vertical',
                    WebkitLineClamp:2,
                    overflow:'hidden',
                    minHeight:'2.5em',
                    color: '#000',
                    background: 'var(--gold)',
                    opacity: 0.92,
                    padding: '8px 12px',
                    borderRadius: '12px',
                    backdropFilter: 'blur(8px)',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.15)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                  }}
                >
                  {a.title}
                </h4>
                {a.desc && (
                  <p
                    style={{
                      margin:0,
                      fontSize:12,
                      opacity:.85,
                      display:'-webkit-box',
                      WebkitBoxOrient:'vertical',
                      WebkitLineClamp:2,
                      overflow:'hidden',
                      color: '#000',
                      background: 'var(--gold)',
                      opacity: 0.88,
                      padding: '6px 10px',
                      borderRadius: '10px',
                      backdropFilter: 'blur(6px)',
                      boxShadow: '0 1px 8px rgba(0, 0, 0, 0.1)',
                      border: '1px solid rgba(255, 255, 255, 0.25)',
                      marginTop: '4px'
                    }}
                  >
                    {a.desc}
                  </p>
                )}
              </div>
            </Link>
          </div>
        ))}
      </HorizontalScroller>
    </Wrap>
  );
}
